import { Badge } from 'react-bootstrap';
import PropTypes from 'prop-types';

/**
 * 数量角标：相对父级（需 position: relative）固定叠在左上角。
 * 不依赖 notification-indicator 的铃铛偏移，避免按钮外布局下跑偏。
 */
const CornerCountBadge = ({ count, max = 99 }) => {
	if (!count || count <= 0) return null;

	const displayCount = count > max ? `${max}+` : count;

	if (count >= 10) {
		return (
			<span className='corner-count-badge corner-count-badge--wide' aria-hidden>
				<Badge bg='danger' pill className='fs-11 px-2'>
					<span className='fw-bolder'>{displayCount}</span>
				</Badge>
			</span>
		);
	}

	return (
		<span className='corner-count-badge' aria-hidden>
			<span className='corner-count-badge__dot'>{displayCount}</span>
		</span>
	);
};

CornerCountBadge.propTypes = {
	count: PropTypes.number,
	max: PropTypes.number,
};

export default CornerCountBadge;
